import React from 'react'

import './content-modal.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import CloseButton from '../close-button/close-button'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    headline?: React.ReactNode
    children?: React.ReactNode
    fullscreenMobile?: boolean
    onClose: React.MouseEventHandler
  }
>

const ContentModal = ({
  className,
  headline,
  children,
  fullscreenMobile,
  onClose,
  ...props
}: Props) => (
  <div {...props} className={cn('ContentModal', {fullscreenMobile: !!fullscreenMobile}, className)}>
    <header className="ContentModal__header">
      <div className="ContentModal__headline">{headline}</div>
      <div className="ContentModal__close">
        <CloseButton onClick={onClose} />
      </div>
    </header>
    <div className="ContentModal__content">{children}</div>
  </div>
)

export default ContentModal
